import { render, staticRenderFns } from "./ServiceAddModal.vue?vue&type=template&id=5901e395&"
import script from "./ServiceAddModal.vue?vue&type=script&lang=js&"
export * from "./ServiceAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports